/* eslint-disable consistent-return */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useIntersectionObserver } from '../../hooks/useObserver';

import { replaceIcons } from '../../lib/utils';

import styles from '../../../styles/blocks/gradient-quote.module.scss';
import Link from '../partials/Link';
import ExternalLinkIcon from '../icons/ExternalLink';

const propTypes = {
    body: PropTypes.string.isRequired,
    author: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    colors: PropTypes.shape({
        type: PropTypes.string,
        colors: PropTypes.arrayOf(PropTypes.string),
    }),
    url: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    authorClassName: PropTypes.string,
};

const defaultProps = {
    author: null,
    align: null,
    colors: null,
    url: null,
    className: null,
    isContainer: false,
    containerClassName: null,
    contentClassName: null,
    authorClassName: null,
};

const GradientQuoteBlock = ({
    body,
    author,
    align,
    colors,
    url,
    className,
    isContainer,
    containerClassName,
    contentClassName,
    authorClassName,
}) => {
    const [animate, setAnimate] = useState(false);

    const { type: colorType = null, colors: customColors = [] } = colors || {};

    const colorStyles = useMemo(() => {
        if (colorType === 'color') return { color: customColors[0] };
        if (colorType === 'gradient') {
            const colorStops = customColors.map((color) => `${color}`);

            return {
                backgroundImage: `linear-gradient(to bottom,  ${colorStops.join(', ')}, ${
                    colorStops[0]
                })`,
            };
        }
        return { color: '#fff' };
    }, [colorType, customColors]);

    const finalBody = replaceIcons(body);

    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-20%' });

    useEffect(() => {
        if (isIntersecting) {
            setAnimate(true);
        }
    }, [isIntersecting]);

    const inner =
        author !== null && url !== null ? (
            <>
                {author !== null ? (
                    <p
                        className={classNames([
                            styles.author,
                            { [authorClassName]: authorClassName !== null },
                        ])}
                        style={{ ...colorStyles }}
                    >
                        -{author}
                    </p>
                ) : null}
                {url !== null ? <ExternalLinkIcon className={styles.linkIcon} /> : null}
            </>
        ) : null;

    const innerLink =
        url !== null ? (
            <Link href={url} className={styles.source} external>
                {inner}
            </Link>
        ) : (
            <div className={styles.source}>{inner}</div>
        );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles[`${align}Align`]]: align,
                    [styles.animated]: animate === true,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
                ref={ref}
            >
                <div
                    className={classNames([
                        styles.content,
                        { [contentClassName]: contentClassName !== null },
                    ])}
                >
                    <blockquote
                        className={styles.body}
                        dangerouslySetInnerHTML={{ __html: finalBody }}
                        style={{ ...colorStyles }}
                    />
                </div>
                {inner !== null ? innerLink : null}
            </div>
        </div>
    );
};

GradientQuoteBlock.defaultProps = defaultProps;
GradientQuoteBlock.propTypes = propTypes;

export default GradientQuoteBlock;
